<template>
  <div
    ref="bar"
    class="header-bar"
    :class="{transparent: transparent, vpadding: vpadding, hpadding: hpadding }"
  >
    <!-- Spans are placeholders just-in-case, to keep Flex working -->
    <back-button
      v-if="showBack"
      :css-class="buttonClass"
    />
    <h1 :style="foregroundStyle">
      {{ title }}
    </h1>
    <help-button
      v-if="showHelp"
      :css-class="buttonClass"
    />
    <menu-button
      v-if="showMenu"
      :css-class="buttonClass"
      @menu-toggle="handleMenuToggle"
    />
    <slideout-menu
      ref="menu"
      :top="height"
      :visible="menuVisible"
    />
  </div>
</template>

<script>
import Config from '@/config.js'
import BackButton from './BackButton.vue'
import HelpButton from './HelpButton.vue'
import MenuButton from './MenuButton.vue'
import SlideoutMenu from './SlideoutMenu.vue'
export default {
  name: 'HeaderBar',
  components: {
      BackButton,
      HelpButton,
      MenuButton,
      SlideoutMenu
  },
  props: {
      showBack: {
          type: Boolean,
          default: true
      },
      showHelp: {
          type: Boolean,
          default: Config.showHelp
      },
      showMenu: {
          type: Boolean,
          default: Config.showMenu
      },
      reverse: {
          type: Boolean,
          default: false
      },
      transparent: {
          type: Boolean,
          default: false
      },
      hpadding: {
          type: Boolean,
          default: false
      },
      vpadding: {
          type: Boolean,
          default: true
      },
      title: {
          type: String,
          default: ''
      },
      foreground: {
          type: String,
          default: 'white'
      }
  },
  data() {
      return {
          height: 0,
          menuVisible: false
      }
  },
  computed: {
      buttonClass() {
          return this.reverse ? "reverse" : ''
      },
      foregroundStyle() {
          return {
              color: this.foreground
          }
      }
  },
  methods: {
      handleMenuToggle(visible) {
          this.height = this.$el.offsetHeight
          this.menuVisible = visible
      }
  }
}
</script>

<style lang="scss" scoped>
h1 {
    flex-grow: 1;
    justify-self: center;
    align-self: center;
    margin: 0 0.5rem;
}
.header-bar {
    display: flex;
    justify-content: space-between;
    background: black;
}
.header-bar.hpadding {
    padding-left: 2rem;
    padding-right: 2rem;
}
.header-bar.vpadding {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.header-bar.transparent {
    background: transparent;
}
.help-button {
    justify-self: right;
}
button {
    align-self: flex-start;
    flex-shrink: 0;
}
</style>
